import React from 'react'
import PropTypes from 'prop-types'
import { Script, graphql, useStaticQuery } from 'gatsby'

const IntegrationPageBreadcrumbSchema = ({
  permalink,
  title,
}) => {
  const { site: { siteMetadata: { siteUrl } } } = useStaticQuery(graphql`
    query IntegrationPageBreadcrumSchemaQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  return (
    <Script type="application/ld+json">
      {`{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Help Scout",
              "item": "${siteUrl}"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Integrations",
              "item": "${siteUrl}/help-desk-integration/"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "${title}",
              "item": "${siteUrl}${permalink}"
             }
          ]
        }`}
    </Script>
  )
}

IntegrationPageBreadcrumbSchema.propTypes = {
  permalink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default IntegrationPageBreadcrumbSchema
